import React, {useEffect, useState} from "react";
import axios from "axios";
import SimpleBar from "simplebar-react";
import {AvField, AvForm} from "availity-reactstrap-validation";
import {Alert} from "reactstrap";
import Select from "react-select";
import customStyles from "../../assets/select/customStyles";
import { useTranslation } from "react-i18next";
import LocalizedDateTimePicker from "../CommonComponents/LocalizedDateTimePicker";

const ReservierungEdit = (props) => {
    const { t } = useTranslation();
    const [buchung, setBuchung] = useState({});
    const [departments, setDepartments] = useState([]);
    const [lotpreferences, setLotpreferences] = useState([]);
    const [lotpreferencesAvailable, setLotpreferencesAvailable] = useState(true);
    const [allParkingscenarios, setAllParkingscenarios] = useState([]);
    const [currentParkingscenarios, setCurrentParkingscenarios] = useState([]);
    const [carParks, setCarParks] = useState([]);

    const [selectedLotPreference, setSelectedLotPreference] = useState();
    const [selectedDepartment, setSelectedDepartment] = useState();
    const [selectedScenario, setSelectedScenario] = useState();
    const [selectedCarPark, setSelectedCarPark] = useState();
    const [selectedTimeFrom, setSelectedTimeFrom] = useState();
    const [selectedTimeTill, setSelectedTimeTill] = useState();

    const [nameRequired, setNameRequired] = useState(false);
    const [emailRequired, setEmailRequired] = useState(false);
    const [companyRequired, setCompanyRequired] = useState(false);

    const [loaderShow, setLoaderShow] = useState(false);
    const [failShow, setFailShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    const activeRights = JSON.parse(localStorage.getItem("rights"));
    const link = localStorage.getItem('link') + '/api/ReservationService';
    const newEntry = !(props.editId > 0);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
        loadData();
    }, []);

    useEffect(()=>{
        if (selectedDepartment?.restrictedToScenario > 0) {
            const scenario = Object.values(allParkingscenarios).flat().find(s => s.value === selectedDepartment.restrictedToScenario);
            buchung.scenarioId = scenario.value;
            buchung.scenario = scenario;
            setBuchung(buchung);
            setSelectedScenario(scenario);
        }
    }, [selectedDepartment]);
    
    const loadData = () => {
        setLoaderShow(true);

        axios.get(link + '/byid?id=' + (props.editId ?? ''), {}).then((response) => {
            console.debug(response.data);
            
            const carParks = response.data.carParks;
            
            setDepartments(response.data.departments);
            setLotpreferences(response.data.parkingLotPreferences);
            setCarParks(carParks);

            setBuchung(response.data.model);

            setSelectedLotPreference(response.data.model.parkingLotPreference);
            setSelectedDepartment(response.data.model.department);
            setSelectedScenario(response.data.model.scenario);

            setNameRequired(response.data.nameRequired);
            setEmailRequired(response.data.eMailRequired);
            setCompanyRequired(response.data.companyRequired);
            setLotpreferencesAvailable(response.data.lotPreferenceAvailable);

            const _selectedCarPark = carParks.find(cp => cp.value === response.data.model.areaIdCarpark);
            setSelectedCarPark(_selectedCarPark);

            if (props.editId > 0) {
                setSelectedTimeFrom(new Date(response.data.model.permissionFrom));
                setSelectedTimeTill(new Date(response.data.model.permissionTill));
            }

            setAllParkingscenarios(response.data.parkingScenariosByCarPark);
            changeCurrentParkingscenarios(response.data.parkingScenariosByCarPark, _selectedCarPark.value);

            setLoaderShow(false);
        })
        .catch((error) => {
            console.error("Error while loading Data", error);
            setLoaderShow(false);
        });
    }
    
    function changeCurrentParkingscenarios(allScenarios, selectedCarParkId) {
        const _currentScenarios = allScenarios[selectedCarParkId];
        setCurrentParkingscenarios(_currentScenarios);
    }

    function handleValidSubmit() {
        setFailShow(false);
        console.debug(buchung);
        axios
        ({
            method: newEntry ? 'post' : 'put',
            url: link,
            data: buchung,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                props.onChange();
            })
            .catch((error) => {
                const customError = getErrorMessage(error.response.status);
                if (customError) {
                    setErrorMessage(customError);
                } else {
                    console.error(error);
                    setErrorMessage(error.message);
                }
                setFailShow(true);
            });
        function getErrorMessage(statusCode) {
            switch (statusCode) {
                case 900:
                    return t("reservationService.quotaExceeded");
                case 901:
                    return t("reservationService.plateAllreadyReserved");
                case 902:
                    return t("reservationService.noCarParkGiven");
                case 903:
                    return t("reservationService.noTimeSpanGiven");
                case 904:
                    return t("reservationService.noNameGiven");
                case 905:
                    return t("reservationService.noCompanyGiven");
                case 906:
                    return t("reservationService.noEmailGiven");
                case 907:
                    return t("reservationService.noLPGiven");
                case 908:
                    return t("reservationService.numberOfDaysExceeded");
            }
            
            return null;
        }
    }

    return (
        <SimpleBar style={{width: "100%", height: "100%"}}>
            <div style={{width: "80%", margin: "auto"}}>
                <div style={{ marginTop: "20px" }}>
                    <h3>
                        {newEntry ? t("reservationService.reservationCreate") : t("reservationService.reservationEdit")}
                    </h3>
                    <AvForm
                        className="form-horizontal"
                        onValidSubmit={() => {
                            handleValidSubmit();
                        }}
                    >
                        {props.error && props.error ? (
                            <Alert color="danger">{props.error}</Alert>
                        ) : null}
                        <table border={0}>
                            <colgroup>
                                <col/>
                                <col/>
                            </colgroup>
                            <tbody>
                            <tr>
                                <td colSpan={2} style={{position: "relative", top: "-9px"}}>
                                    <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.carPark")}:</div>
                                    <Select
                                        styles={customStyles}
                                        name="areaIdCarpark"
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(carPark) => {
                                            buchung.areaIdCarpark = carPark.value;
                                            setBuchung(buchung);
                                            setSelectedCarPark(carPark);

                                            changeCurrentParkingscenarios(allParkingscenarios, carPark.value);
                                        }}
                                        options={carParks}
                                        value={selectedCarPark}
                                        required
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 3,
                                            colors: { ...theme.colors, primary: "#20a0ff" },
                                        })}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <AvField
                                        style={{ height: "25px" }} className="form-control"
                                        name="company"
                                        label={t("reservationService.formHeader.company") + (companyRequired ? "*": "") + ":"}
                                        value={buchung?.company ?? ''}
                                        required={companyRequired}
                                        onChange={(e) => {
                                            buchung.company = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <AvField
                                        style={{height: "25px"}} className="form-control"
                                        value={buchung?.firstname ?? ''}
                                        name="firstname"
                                        required={nameRequired}
                                        label={t("reservationService.formHeader.firstname") + (nameRequired ? "*": "") + ":"}
                                        onChange={(e) => {
                                            buchung.firstname = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                                <td>
                                    <AvField
                                        style={{height: "25px"}} className="form-control"
                                        value={buchung?.lastname ?? ''}
                                        name="lastname"
                                        required={nameRequired}
                                        label={t("reservationService.formHeader.lastname") + (nameRequired ? "*": "") + ":"}
                                        onChange={(e) => {
                                            buchung.lastname = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <AvField
                                        style={{height: "25px"}} className="form-control"
                                        value={buchung?.eMail ?? ''}
                                        name="eMail"
                                        label={t("reservationService.formHeader.email") + (emailRequired ? "*": "") + ":"}
                                        required={emailRequired}
                                        type="email"
                                        onChange={(e) => {
                                            buchung.eMail = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <AvField
                                        style={{height: "25px"}} className="form-control"
                                        value={buchung?.numberPlate ?? ''}
                                        name="numberPlate"
                                        label={t("reservationService.formHeader.numberPlate") + "*:"}
                                        required
                                        onChange={(e) => {
                                            buchung.numberPlate = e.target.value;
                                            setBuchung(buchung);
                                        }}
                                    />
                                </td>
                                <td style={{position: "relative", top: "-9px"}}>
                                    {lotpreferencesAvailable &&
                                    <>    
                                        <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.lotPreference")}:</div>
                                        <Select
                                            styles={customStyles}
                                            name="parkingLotPreference"
                                            closeMenuOnSelect={true}
                                            isSearchable={false}
                                            isMulti={false}
                                            onChange={(lotpreference) => {
                                                buchung.parkingLotPreference = lotpreference;
                                                buchung.parkingLotPreferenceValue = lotpreference.value;
                                                setBuchung(buchung);
                                                setSelectedLotPreference(lotpreference);
                                            }}
                                            options={lotpreferences}
                                            value={selectedLotPreference}
                                            required
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 3,
                                                colors: { ...theme.colors, primary: "#20a0ff" },
                                            })}
                                        />
                                    </>}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.from")}*:</div>
                                    <LocalizedDateTimePicker
                                        includeTime
                                        style={{ width: "100%" }}
                                        className="datetime-picker"
                                        value={selectedTimeFrom}
                                        required
                                        onChange={(value)=>{
                                            buchung.permissionFrom = value;
                                            setBuchung(buchung);
                                            setSelectedTimeFrom(value);
                                        }}
                                    />
                                </td>
                                <td>
                                    <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.till")}*:</div>
                                    <LocalizedDateTimePicker
                                        includeTime
                                        style={{ width: "100%" }}
                                        className="datetime-picker"
                                        value={selectedTimeTill}
                                        required
                                        onChange={(value)=>{
                                            buchung.permissionTill = value;
                                            setBuchung(buchung);
                                            setSelectedTimeTill(value);
                                        }}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td style={{paddingTop: "20px"}}>
                                    <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.department")}:</div>
                                    <Select
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(department) => {
                                            buchung.departmentId = department.value;
                                            buchung.department = department;
                                            setBuchung(buchung);
                                            setSelectedDepartment(department);
                                        }}
                                        options={departments}
                                        value={selectedDepartment}
                                    />
                                </td>
                                <td style={{paddingTop: "20px"}}>
                                    <div style={{marginBottom: "10px"}}>{t("reservationService.formHeader.scenario")}:</div>
                                    <Select
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        isSearchable={false}
                                        isMulti={false}
                                        onChange={(scenario) => {
                                            buchung.scenarioId = scenario.value;
                                            buchung.scenario = scenario;
                                            setBuchung(buchung);
                                            setSelectedScenario(scenario);
                                        }}
                                        options={currentParkingscenarios}
                                        value={selectedScenario}
                                    />
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colSpan={2} style={{textAlign: "right", paddingTop: "20px"}}>
                                    <button className="button" onClick={() => props.onChange()} style={{width: "100px"}}>
                                        {t("allgemein.abbruch")}
                                    </button>
                                    
                                    <button type="submit" className="button" style={{width: "100px", marginLeft: "10px"}}>
                                        {t("allgemein.speichern")}
                                    </button>
                                </td>
                            </tr>
                            {failShow === true && (
                                <tr><td colSpan={2} style={{textAlign: "right", color: "#f46a6a"}}>{errorMessage}</td></tr>
                            )}
                            </tfoot>
                        </table>
                    </AvForm>
                </div>
            </div>
        </SimpleBar>
    );
};

export default ReservierungEdit;
